
import * as gtUtil from "../../../core/utility";
import { HandlesService } from "../../../core/services/handles.service";

const handlesService = new HandlesService();
interface Props {
    userData: any;
    updateUser: any;
    setLoader:any
}


export const instagramConnectFn = async (userData: { influencer_id: any; }, updateUser: any, setLoader: any) => {
  try {
    const response = await handlesService.instagramConnect();

    if (response.status === gtUtil.Constants.SUCCESS) {
      const popup = window.open(response.data.url, "_blank", "width=500,height=600");

      const channel = new BroadcastChannel('oauth-channel');

      channel.onmessage = async (event) => {
        if (event.data?.type === 'social-auth-success') {
          const authCode = event.data.code;
          channel.close();

          setLoader(true);

          const res = await handlesService.postInstagramConnect({
            code: authCode,
            influencer_id: userData.influencer_id,
          });

          if (res.status === gtUtil.Constants.SUCCESS) {
            const userService = new (await import('../../../core/services')).UserService();
            const latest = await userService.getUpdatedUserReducer(userData);
            // No refresh for a Talent Partner / Agency (undefined): keep the
            // picked creator's UserData rather than clearing it.
            if (![undefined, null, ''].includes(latest)) updateUser(latest);
          }

          setLoader(false);
        }
      };
    }
  } catch (err) {
    console.error(err);
    setLoader(false);
  }
};